export const PRODUCT_CATEGORIES_QUERY_KEY = 'productCategories';
export const PRODUCT_SUBCATEGORIES_QUERY_KEY = 'productSubcategories';
